module.exports = __webpack_public_path__ + "static/media/gnurl.fe91bc6a.svg";